import type { LocationProviders } from '~~/core/ports/repositories/LocationAutocomplete';

/**
 * Configuração reutilizável para busca **só por local** (região/cidade):
 * sem código de imóvel, autocomplete limitado a regiões/cidades e histórico sem rua/POI.
 *
 * **SRP (listagem):** não usa isto — mantém código, ruas e histórico completo.
 */
export interface SearchSuggestGeoOnlyConfig {
	providers: LocationProviders[];
	hideCodeSearch: true;
	excludeStreetAndPoiFromLastResearchs: true;
}

export function useSearchSuggestGeoOnlyConfig(): SearchSuggestGeoOnlyConfig {
	return {
		providers: ['regions', 'cities'],
		hideCodeSearch: true,
		excludeStreetAndPoiFromLastResearchs: true
	};
}
